/** Vilka rader som ska ritas för den synliga delen av listan. */
export function visibleRowWindow(
  scrollTop: number,
  viewport: number,
  count: number,
  rowHeight: number,
  overscan: number
): { start: number; end: number } {
  if (count <= 0 || rowHeight <= 0 || viewport <= 0) return { start: 0, end: 0 };
  const start = Math.max(0, Math.floor(scrollTop / rowHeight) - overscan);
  const end = Math.min(count, Math.ceil((scrollTop + viewport) / rowHeight) + overscan);
  return { start, end };
}
